import {load_products, show_loading} from './product-catalog'
import {RangeSlider} from "../../organisms/range-slider";
import {open_collapse} from './../../organisms/filter-collapse'

(function ($) {

	class ProductCatalogFilters {

		form_class = 'product-catalog-filters'
		filters = {}
		load_delay = null

		constructor() {

			// Show active filters
			this.display_active_filters()

			// Trigger change
			$('form.product-catalog-filters').gp_on('change', this.form_changed)

			// Open sidebar instead of dropdown on mobile
			$(document).on('open_filter_dropdown', this.open_dropdown)

			// Bind reset
			$('[data-reset-filters]').gp_on('click', this.reset_all_filters)

		}

		get_forms() {
			return $('form.' + this.form_class)
		}

		get_filter_url(url_base) {

			// URL object does not support relative path, add protocol
			if (url_base.startsWith('//')) {
				url_base = 'http:' + url_base
			}

			let url = new URL(url_base),
				active_filters = this.get_active_filters()

			// Build filter query
			for (const [name, data] of Object.entries(active_filters)) {
				url.searchParams.set(name, data.values.map(object => object.value).join(','));
			}

			return url.toString()
		}

		form_changed = (e) => {

			let $form = $(e.currentTarget)

			// Sync forms
			this.sync_forms($form)

			// Set active filters
			this.display_active_filters()

			// Clear timeout to prevent spam
			clearTimeout(this.load_delay)

			// Show loading
			show_loading(true)

			// Wait 0,5sec - prevent request spam caused by fast clicks etc. in filters
			this.load_delay = setTimeout(() => {
				let request = load_products(this.get_filter_url($form.attr('action')), false)

				request.done((response, textStatus, jqXHR) => {
					// Update count in sidebar button
					this.update_total_products(response.data.total_products)
				});

			}, 500)

		}

		get_active_filters($form) {

			let form_data = this.get_forms().serializeArray(),
				filters = {}

			form_data.forEach((input) => {

				let name = input.name,
					value = input.value

				// Find value title
				let $inputs = null,
					filter_name = '',
					value_name = ''

				if (name == 'price_from' || name == 'price_to') {
					$inputs = this.get_forms().find('input[name="' + name + '"]')
					filter_name = $inputs.eq(0).data('label')
					value_name = $inputs.eq(0).val() + ' ' + $inputs.eq(0).data('unit')

					// Skip when value is on edge
					if (
						name == 'price_from' && $inputs.eq(0).attr('min') == value
						|| name == 'price_to' && $inputs.eq(0).attr('max') == value
					) {
						return;
					}

				} else {
					$inputs = this.get_forms().find('[name="' + name + '"][value="' + value + '"]')

					filter_name = $inputs.eq(0).data('filter-name')
					value_name = $inputs.eq(0).data('value-name')
				}

				if (value) {
					let value_object = {
						name: value_name,
						value: value,
						$inputs: $inputs
					}

					if (!filters[name]) {
						filters[name] = {
							filter_name: filter_name,
							values: [value_object]
						}
					} else if (!filters[name].values.some(object => object.value === value)) { // if not exist
						filters[name].values.push(value_object)
					}
				}
			})

			return filters;
		}

		get_inputs(name, value = '') {
			if (value) {
				return this.get_forms().find('[name="' + name + '"][value="' + value + '"]')
			} else {
				return this.get_forms().find('[name="' + name + '"]')
			}
		}

		sync_forms($changed_form) {

			let $other_forms = this.get_forms().not($changed_form)

			// Sync check inputs
			$changed_form.find('input[type=checkbox], input[type=radio]').each(function () {
				let name = $(this).attr("name"),
					value = $(this).attr("value"),
					is_checked = $(this).is(":checked")

				$other_forms.find("input[name='" + name + "'][value='" + value + "']").prop("checked", is_checked)
			})

			// Sync number inputs (range sliders)
			$changed_form.find('.range-slider').each(function () {

				let range_slider = new RangeSlider($(this)),
					values = range_slider.get_values()

				$other_forms.find('.range-slider').each(function () {
					let other_range_slider = new RangeSlider($(this))

					// Update
					other_range_slider.set_values(values[0], values[1])
				})
			})

		}

		reset_filter(name, value = '') {

			if (name == 'price_from') {
				this.get_forms().find('.range-slider').each(function () {
					let range_slider = new RangeSlider($(this))
					range_slider.reset_from_value()
				})
			} else if (name == 'price_to') {
				this.get_forms().find('.range-slider').each(function () {
					let range_slider = new RangeSlider($(this))
					range_slider.reset_to_value()
				})
			} else {
				this.get_inputs(name, value).prop('checked', false)
			}

			this.get_forms().trigger('change')
		}

		reset_all_filters = () => {
			let active_filters = this.get_active_filters()
			for (const [name, data] of Object.entries(active_filters)) {
				this.reset_filter(name)
			}
		}

		display_active_filters() {

			let $container = $('.product-catalog-filtration__filtered-container'),
				active_filters = this.get_active_filters(),
				total_active = 0

			// Empty first
			$container.empty()
			$('.filter-collapse__filtered').empty()

			// Show/hide sidebar reset button
			if (Object.keys(active_filters).length > 0) {
				$('.sidebar-product-catalog-filtration__reset').show()
			} else {
				$('.sidebar-product-catalog-filtration__reset').hide()
			}

			// Build filter query
			for (const [name, filter_data] of Object.entries(active_filters)) {
				filter_data.values.forEach((value_data) => {
					total_active++

					// Find title
					let title = ''
					if (name == 'price_from' || name == 'price_to') {
						title = filter_data.filter_name + value_data.name
					} else {
						title = value_data.name
					}

					if (!title) {
						return
					}

					// Use template
					let active_filter_template = document.getElementById('active-filter-template')

					// Append first bind
					let $active_filter = $(active_filter_template.content.cloneNode(true)).children().appendTo($container)

					$active_filter.find('.control-button__title').text(title)

					// Bind reset click
					$active_filter.click(() => {
						this.reset_filter(name, value_data.value)
					})
				})

				// Collapse in filters
				this.get_forms().find('.filter-collapse[data-filter="' + name + '"]').each(function () {

					let $collapse_container = $(this).find('.filter-collapse__filtered')

					// Empty first
					$collapse_container.empty()

					// List active filters
					$collapse_container.text(filter_data.values.map(object => object.name).join(', '))
				})

			}

			// Show reset all
			if (total_active > 1) {
				let reset_filters_template = document.getElementById('reset-filters-template')
				let $active_filter = $(reset_filters_template.content.cloneNode(true)).children().appendTo($container)

				// Bind reset on click
				$active_filter.click(() => {
					this.reset_all_filters()
				})
			}

		}

		update_total_products(count) {
			$('.sidebar-product-catalog-filtration__submit-count').text(' (' + count + ')')
		}

		open_dropdown(event, data) {
			if (window.innerWidth < 768) {
				// Open sidebar instead
				data.open_dropdown = false
				$(document).trigger('open_modal', 'product-catalog-filtration')
				let $filter = $('.sidebar-product-catalog-filtration').find("[data-filter='" + data.filter + "']")
				open_collapse($filter)
			}
		}
	}

	new ProductCatalogFilters()

})(jQuery);